import React, { useState, useCallback, useMemo } from 'react';
import { Typography, Divider, Paper, Grid, Box, Button, TextField, Stack } from '@mui/material';
import { useSnackbar } from 'notistack';
import Modal from 'components/Modal';
import AddIcon from '@mui/icons-material/Add';
import AddIncentive from './add';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import { getIncentives } from 'services/incentives';
import { LocalizationProvider, MobileDateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import VendorSelect from 'components/vendorSelect';
import { getDbFormat } from 'utils/common';
import { isValid } from 'date-fns';
import VendorLibraries from 'components/vendorLibraries';
import { reactDataGridExportCSV } from 'components/reactdata-grid';
import DownloadIcon from '@mui/icons-material/Download';

const IncentivesPage = () => {

  const gridStyle = useMemo(() => ({ minHeight: 480, width: '100%' }), []);
  const [ filterDates, setFilterDates] = React.useState([new Date(), new Date()]);
  const [ pageFilters, setPageFilters] = React.useState({filterDates});
  const [gridRef, setGridRef] = useState(null);

  const [incentives, setIncentives] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if(isValid(fromDate) && isValid(toDate)) {
      setFilterDates(data);
      setPageFilters({...pageFilters, filterDates: data});
    }else{
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }


  // const defaultFilterValue = [
  //   { name: 'Property', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Vendor', operator: 'contains', type: 'string', value: '' },
  //   { name: 'description', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Amount', operator: 'contains', type: 'string', value: '' },
  //   { name: 'createdOn', operator: 'contains', type: 'string', value: '' },
  // ];
  const columns = useMemo(() => ([
    { name: 'description', header: 'Description', width: 420},
    { name: 'amount', header: 'Amount', width: 200},
    { name: 'target', header: 'Transferred to', width: 180},
    { name: 'createdOn', header: 'Date', width: 200},
  ]),[]);

  // useEffect(() => {
  //  if(pageFilters?.filterDates && pageFilters?.vendor && pageFilters?.library){
  //   getIncentivesData()
  //  }
  // }, [pageFilters]);

  function getIncentivesData() {
    let [fromDate, toDate ]= pageFilters.filterDates;
    fromDate= getDbFormat(fromDate);
    toDate= getDbFormat(toDate);
    const propertyId= pageFilters.library.id;
    const vendorId= pageFilters.vendor.userId;
    getIncentives({fromDate, toDate, propertyId, vendorId}).then(({response, error}) => {
      if(response){
        setIncentives(response);
      } else {
        setIncentives([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

 
  const onSuccess = function (){
      setOpenModal(false);
      getIncentivesData();
  }

  const onLibrarySelected = useCallback((library) => {
    if(pageFilters?.library?.id !== library?.id){
      setPageFilters({...pageFilters, library});
    }
  }, [pageFilters]);

  const onVendorSelected = useCallback((vendor) => {
    if(pageFilters?.vendor?.userId !== vendor?.userId){
      setPageFilters({...pageFilters, vendor});
    }
  }, [pageFilters]);

  function onGoBtnClick() {
    if(!(pageFilters?.filterDates)){
      enqueueSnackbar("Select from date and to date", {variant: 'error'});
      return;
    }
    if(!(pageFilters?.vendor)){
      enqueueSnackbar("Select vendor", {variant: 'error'});
      return;
    }
    if(!(pageFilters?.library)){
      enqueueSnackbar("Select library", {variant: 'error'});
      return;
    }
    getIncentivesData();
  }

  function onAddIncentiveBtnClick() {
    setOpenModal(true)
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Incentives
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container>
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{p:1, bgcolor: "#f3f3f3"}}>
            <Typography variant="subtitle2" gutterBottom component="div">
              Filters
            </Typography>
            <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} columnSpacing={1}>
              <Grid item sx={{mt: 2}} xs={12} sm={12} md={4} xl={4} lg={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateRangePicker
                    inputFormat="dd/MM/yyyy"
                    startText="From Date"
                    endText="To Date"
                    value={filterDates}
                    // clearable={true}
                    onChange={(newValue) => {
                      // setFilterDates(newValue);
                    }}
                    onAccept={(data) => onDateAccepted(data)}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                        <Box sx={{ mx: 2 }}> to </Box>
                        <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                      </React.Fragment>
                    )}
                    />
                </LocalizationProvider>
              </Grid>
              <Grid item sx={{pt: 2, }} xs={12} sm={5} md={3} xl={3} lg={3}>
                <VendorSelect onVendorSelected={onVendorSelected}/>
              </Grid>
              <Grid item sx={{pt: 2, }} xs={12} sm={5} md={3} xl={3} lg={3}>
                <VendorLibraries onLibrarySelected={onLibrarySelected} variant="outlined" vendorId={pageFilters?.vendor?.userId} />
              </Grid>
              <Grid item sx={{pt: 2, }} xs={4} sm={2} md={2} xl={2} lg={2}>
                <Button variant="contained" onClick={onGoBtnClick} sx={{textTransform:'none', fontSize: 14, py: '7px'}}>Go</Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} textAlign="right"  sx={{mt: 3}}>
            <Stack direction="row" justifyContent="space-between">
              <Button onClick={() => reactDataGridExportCSV(gridRef, 'Incentives.csv') } startIcon={<DownloadIcon />} variant="outlined" color="success" sx={{textTransform: 'none'}}>Export CSV</Button>
              <Button color="success" variant="contained" startIcon={<AddIcon />} onClick={onAddIncentiveBtnClick}>
                Add Incentive
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Box component="div" sx={{  mt: 3 ,  maxHeight: 720, width: '100%' }}>
              <ReactDataGrid
                handle={setGridRef}
                idProperty="index"
                style={gridStyle}
                // defaultFilterValue={defaultFilterValue}
                columns={columns}
                dataSource={incentives}
                rowHeight={null} 
                minRowHeight={50}
              />
            </Box>
          </Grid>
        </Grid>
      </Box> 
      <Modal  maxWidth={"sm"} open={openModal} onModalClose={onModalClose} title={'Add Incentive'}>
        <AddIncentive  onSuccess={onSuccess} onFailure={onModalClose} pageFilters={pageFilters} />
      </Modal>
    </Paper>
  );
}
 
export default IncentivesPage;
